import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";

const DeleteConfirmationDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  isDeleting = false,
  message = null,
  currentUserId = null
}) => {
  const [deleteFor, setDeleteFor] = useState("me");
  const [canDeleteForEveryone, setCanDeleteForEveryone] = useState(false);

  useEffect(() => {
    if (!isOpen || !message) {
      setDeleteFor("me");
      setCanDeleteForEveryone(false);
      return;
    }

    // Check if message is from current user
    const isMyMessage = message.sender?._id === currentUserId;
    
    // Check if message was created within last 12 hours
    const messageTime = new Date(message.createdAt);
    const now = new Date();
    const hoursDiff = (now - messageTime) / (1000 * 60 * 60);
    const isWithin12Hours = hoursDiff <= 12;

    // Can delete for everyone only if:
    // 1. It's my own message
    // 2. It was sent within last 12 hours
    // 3. Message is not already deleted
    const canDelete = isMyMessage && isWithin12Hours && !message.isDeleted;
    setCanDeleteForEveryone(canDelete);
    
    // Reset to 'me' when dialog opens
    setDeleteFor("me");
  }, [isOpen, message, currentUserId]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(deleteFor);
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1060,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '12px',
          maxWidth: '400px',
          width: '100%',
          padding: '24px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h5 className="mb-3">Delete Message</h5>
        <p className="text-muted mb-4">
          Are you sure you want to delete this message?
        </p>
        
        {/* Delete options */}
        <div className="mb-4">
          <div 
            className="form-check mb-2"
            style={{ cursor: 'pointer' }}
          >
            <input
              className="form-check-input"
              type="radio"
              name="deleteFor"
              id="deleteForMe"
              checked={deleteFor === "me"}
              onChange={() => setDeleteFor("me")}
              disabled={isDeleting}
              style={{ cursor: 'pointer' }}
            />
            <label 
              className="form-check-label" 
              htmlFor="deleteForMe"
              style={{ cursor: 'pointer', userSelect: 'none' }}
            >
              Delete for me
            </label>
          </div>
          
          {canDeleteForEveryone && (
            <div 
              className="form-check"
              style={{ cursor: 'pointer' }}
            >
              <input
                className="form-check-input"
                type="radio"
                name="deleteFor"
                id="deleteForEveryone"
                checked={deleteFor === "everyone"}
                onChange={() => setDeleteFor("everyone")}
                disabled={isDeleting}
                style={{ cursor: 'pointer' }}
              />
              <label 
                className="form-check-label" 
                htmlFor="deleteForEveryone"
                style={{ cursor: 'pointer', userSelect: 'none' }}
              >
                Delete for everyone
              </label>
            </div>
          )}
        </div>

        {/* {!canDeleteForEveryone && (
          <div 
            className="alert alert-info py-2 px-3 mb-3" 
            style={{ fontSize: '0.85rem' }}
          >
            <i className="ri-information-line me-1"></i>
            {message?.sender?._id !== currentUserId 
              ? "You can only delete received messages for yourself"
              : "Messages can only be deleted for everyone within 12 hours"
            }
          </div>
        )} */}
        
        <div className="d-flex gap-2 justify-content-end">
          <Button
            color="secondary"
            onClick={onClose}
            disabled={isDeleting}
            style={{ minWidth: '80px' }}
          >
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={handleConfirm}
            disabled={isDeleting}
            style={{ minWidth: '80px' }}
          >
            {isDeleting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationDialog;